export default {
  form: {
    display_name: {
      label: 'Restaurant name',
      placeholder: 'Enter restaurant name',
      help: 'Used on your contract and invoices',
    },
    store_address: {
      label: 'Store address',
      placeholder: 'Search for your address',
      help: 'This is the address your customers see',
    },
    address: {
      label: 'Address',
      placeholder: 'Street + number',
    },
    zip_code: {
      label: 'Postal code',
      placeholder: 'Postal code',
    },
    city: {
      label: 'City',
      placeholder: 'City',
    },
    state: {
      label: 'State',
      placeholder: 'Select state',
    },
    country: {
      label: 'Country',
      help: 'To move your restaurant to another country, contact support',
    },
  },
  staff_notice:
    "Store staff cannot confirm the restaurant's name and address. Please ask your onboarding manager to check these details.",
  toasts: {
    saved: 'Store details saved',
    error: 'Your store details could not be saved',
  },
  buttons: {
    next: 'Next',
  },
};
